<p style="font-size: 24px;margin-bottom: 25px; padding-left:20px;"><strong>Inserire criteri di filtro per navigare nel QRSP.</strong></p>

<p style="padding-left:20px;"><strong>Criteri per profilo.</strong></p>

<mat-form-field class="half-width-a" *ngIf="areas">
  <mat-label>Area professionale</mat-label>
  <mat-select [(ngModel)]="tipoAreaProfilo" name="area" (ngModelChange)="handleAreaChange($event)">
    <mat-option *ngFor="let item of areas" [value]="item">
      {{item.descrizione}}
    </mat-option>
  </mat-select>
</mat-form-field>

<mat-form-field class="half-width">
  <mat-label>Profilo professionale</mat-label>
  <!-- text input -->
  <input matInput placeholder="Profilo professionale" value="{{descrizioneProfilo}}"
         [(ngModel)]="descrizioneProfilo" name="descrizione">
</mat-form-field>

<!-- Toggle per Green e Digital -->
<div class="toggle-row" style="padding-left:20px;">
  <div class="toggle-item">
    <p class="text-lg">Solo competenze digitali</p>
    <label class="switch">
      <input type="checkbox" [(ngModel)]="isDigital" name="toggleDigital" (change)="onDigitalToggleChange()">
      <span class="slider round"></span>
    </label>
  </div>

  <div class="toggle-item2">
    <p class="text-lg">Solo competenze green</p>
    <label class="switch">
      <input type="checkbox" [(ngModel)]="isGreen" name="toggleGreen" (change)="onGreenToggleChange()">
      <span class="slider round"></span>
    </label>
  </div>
</div>

<div style="clear: both; overflow: auto; margin-bottom: 20px;">
  <button mat-fab extended
          class="searchbox-buttons ricerca-button"
          (click)="filterSearch()"
          [disabled]="atLeastOneFilterInserted">
    <mat-icon>filter_alt</mat-icon>Filtra
  </button>
  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="reset()">
    <mat-icon>undo</mat-icon>Ripristina
  </button>
</div>


<!-- Ordinamento aree - Moved below buttons and left-aligned -->
<div class="ordinamento-container">
  <p class="ordinamento-label">Ordinamento aree</p>
  <mat-button-toggle-group name="ordinamento" [(ngModel)]="tipoOrdinamento" (change)="ordinaAree()">
    <mat-button-toggle value="id">
      <mat-icon>format_list_numbered</mat-icon>
      Per ID
    </mat-button-toggle>
    <mat-button-toggle value="alfabetico">
      <mat-icon>sort_by_alpha</mat-icon>
      Alfabetico (A-Z)
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>


<div style="margin-top: 50px; padding: 10px"> <!-- Adjusted margin-top -->
  <div *ngIf="!tipologieArea.length && fetchedContent" style="display: flex">
    <mat-icon style="color : #008047;margin-top: 10px; margin-left: auto; margin-right: 10px;">sentiment_dissatisfied</mat-icon>
    <p style="font-weight: bold; font-size: 24px;margin-top: 10px; margin-left : 0px; margin-right: auto">La ricerca non ha prodotto alcun risultato...</p>
  </div>
  <div *ngFor="let tipologia of tipologieArea">

    <tile
      [displayText]="tipologia.descrizione"
      bgColor="dark-green"
      [showDetailIcon]="false"
      (onTileClick)="getProfilesByTipologia(tipologia)" />


    <div [@slideInOut]="tipologia.showChild ? 'in' : 'out'">
      <div *ngIf="!mapTipologiaAreaIdToProfili.get(tipologia.id)?.length && tipologia.quered" style="display: flex">
        <mat-icon style="color : #008047;margin-top: 10px; margin-left: auto; margin-right: 10px;">sentiment_dissatisfied</mat-icon>
        <p style="font-weight: bold; font-size: 24px;margin-top: 10px; margin-left : 0px; margin-right: auto">Non ci sono Profili da mostrare per la tipologia selezionata</p>
      </div>

      <p *ngIf="mapTipologiaAreaIdToProfili.get(tipologia.id)?.length" style="margin-left: 50px; margin-top: 20px; font-size: 20px;"><strong>Profili:</strong></p>

      <div *ngFor="let profilo of mapTipologiaAreaIdToProfili.get(tipologia.id);">
        <tile
          [displayText]="profilo.nomeProfilo"
          bgColor="green"
          [eqfLevel]="profilo.livelloEqf"
          [offSetMarginLeft]="40"
          (onView)="showDetailProfilo(profilo)"
          (onTileClick)="getCompetenzeByIdProposta(profilo)"/>

        <div [@slideInOut]="profilo.showChild ? 'in' : 'out'">
          <div *ngIf="!mapIdPropostaToCompetenze.get(profilo.idProposta)?.length && profilo.quered" style="display: flex">
            <mat-icon style="color : #008047; margin-top: 10px; margin-left: auto; margin-right: 10px;">sentiment_dissatisfied</mat-icon>
            <p style="font-weight: bold; font-size: 24px;margin-top: 10px; margin-left : 0px; margin-right: auto">Non ci sono competenze da mostrare per il profilo selezionato</p>
          </div>

          <p *ngIf="mapIdPropostaToCompetenze.get(profilo.idProposta)?.length" style="margin-left: 100px; margin-top: 20px; font-size: 20px;"><strong>Competenze:</strong></p>

          <div *ngFor="let competenza of mapIdPropostaToCompetenze.get(profilo.idProposta);">
            <tile
              [displayText]="competenza.descrizione"
              bgColor="light-green"
              [eqfLevel]="competenza.eqfCompetenza"
              [offSetMarginLeft]="90"
              (onView)="showDetailCompetenza(competenza)"
              (onTileClick)="getAbilitaConoscenze(competenza)"/>


            <div [@slideInOut]="competenza.showChild ? 'in' : 'out'">



              <div *ngIf="!mapCompetenzaIdToConoscenza.get(competenza.id)?.length" style="display: flex">
                <mat-icon style="color : #008047;margin-top: 10px; margin-left: auto; margin-right: 10px;">sentiment_dissatisfied</mat-icon>
                <p style="font-weight: bold; font-size: 24px;margin-top: 10px; margin-left : 0px; margin-right: auto">Non ci sono conoscenze da mostrare per questa competenza</p>
              </div>

              <p *ngIf="mapCompetenzaIdToConoscenza.get(competenza.id)?.length" style="margin-left: 140px; margin-top: 20px; font-size: 20px;"><strong>Conoscenze:</strong></p>


              <ul style="margin-bottom: 30px;">
                <li  *ngFor="let conoscenza of mapCompetenzaIdToConoscenza.get(competenza.id)">
                  {{conoscenza.descrizione}}
                </li>
              </ul>

              <div *ngIf="!mapCompetenzaIdToAbilita.get(competenza.id)?.length && competenza.quered" style="display: flex; margin-top: 30px;">
                <mat-icon style="color : #008047;margin-top: 10px; margin-left: auto; margin-right: 10px;">sentiment_dissatisfied</mat-icon>
                <p style="font-weight: bold; font-size: 24px;margin-top: 10px; margin-left : 0px; margin-right: auto">Non ci sono abilita da mostrare per la competenza selezionata</p>
              </div>

              <p *ngIf="mapCompetenzaIdToAbilita.get(competenza.id)?.length" style="margin-left: 140px; margin-top: 20px; font-size: 20px;"><strong>Abilità:</strong></p>

              <ul>
                <li  *ngFor="let abilita of mapCompetenzaIdToAbilita.get(competenza.id) ">
                  {{abilita.descrizione}}
                </li>
              </ul>
            </div>

          </div>
        </div>

      </div>
    </div>

  </div>
</div>
